<template>
    <tr
        v-if="staff"
        class="relative group"
    >
        <td class="px-1 py-1">
            <div class="flex items-center ml-1 space-x-2 pointer">
                <img
                    class="w-6 h-6 rounded-full shadow"
                    :src="staff.avatar"
                    alt="staff avatar"
                >
                <span class="text-xs truncate">{{ staff.name }}</span>
            </div>
            <div class="flex items-center justify-between ml-1">
                <div class="font-normal text-gray-500">
                    {{ staffAttendance.classroom ? staffAttendance.classroom.name : '' }}
                </div>
            </div>
            <div class="flex items-center justify-between">
                <div
                    v-if="staff.total_hours"
                    class="pr-1 text-xs text-right text-gray-500"
                >
                    Théorique: {{ staff.total_hours.toString().replace('.', ',') }}h
                </div>
                <div
                    v-if="staff.real_total_hours && canSeeRealHours"
                    class="pr-1 text-xs text-right text-gray-500"
                >
                    Réel: {{ staff.real_total_hours.toString().replace('.', ',') }}h
                </div>
            </div>
            <div
                v-if="[3, 4, 5, 6, 7, 8].includes(staffAttendance.type)"
                class="font-semibold text-center text-red-500"
            >
                ABSENT
            </div>
        </td>

        <td
            v-for="(qH, index) in quarterHours"
            :key="qH"
            :class="[color, {
                'bg-attendance-reservation': isPresent(qH) && !(canSeeRealHours && isRealPresent(qH)),
                'bg-attendance-presence': canSeeRealHours && isRealPresent(qH)
            }]"
        >
            <div
                v-if="index===0 && accessStaff"
                class="absolute inset-0 print:hidden flex items-center justify-center opacity-0 group-hover:opacity-100"
            >
                <UiButtonModal :id="'staff-attendance-edit'+staffAttendance.uuid">
                    <template #trigger>
                        <svg

                            class="w-6 h-6 text-blue-900"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                            />
                        </svg>
                    </template>
                    <staff-attendance-edit-form
                        :staff="staff"
                        :staff-attendance="staffAttendance"
                        @updated="updated"
                    />
                </UiButtonModal>
            </div>
        </td>
    </tr>
</template>

<script>
import dayjs from 'dayjs'
import { types } from 'abcreche-constants/src/const/staffs/attendances/types'
import isBetween from 'dayjs/plugin/isBetween'
import { dateRangeMixin } from 'abcreche-ui'
import permissionsMixin from '~~/mixins/permissionsMixin.js'

dayjs.extend(isBetween)

export default {
    mixins: [dateRangeMixin, permissionsMixin],

    props: {
        staffAttendance: {
            type: Object,
            required: true
        },
        staff: {
            type: Object,
            required: true
        },
        rangeFrom: {
            type: Object,
            required: true
        },
        rangeTo: {
            type: Object,
            required: true
        }
    },

    emits: ['updated'],

    computed: {
        canSeeRealHours () {
            return this.accessStaff || this.staff?.user?.uuid === this.$user?.uuid
        },

        duration () {
            if (this.staffAttendance) {
                let total = Math.abs(dayjs(this.staffAttendance.should_start_at).diff(this.staffAttendance.should_left_at, 'hours', true))
                if (this.staffAttendance.pause_start_at) {
                    total -= Math.abs(dayjs(this.staffAttendance.date + ' ' + this.staffAttendance.pause_start_at).diff(this.staffAttendance.date + ' ' + this.staffAttendance.pause_stop_at, 'hours', true))
                }
                return total
            }
            return null
        },
        quarterHours () {
            return this.generateDateRange(
                this.rangeFrom,
                this.rangeTo,
                15,
                'minutes',
                'HH:mm'
            )
        },
        color () {
            return types().find(type => type.value === this.staffAttendance.type).color
        }
    },

    methods: {
        isPresent (qH) {
            if (this.staffAttendance.pause_start_at && this.staffAttendance.pause_stop_at) {
                const inPause = dayjs(
                    this.staffAttendance.date + ' ' + qH
                ).isBetween(this.staffAttendance.date + ' ' + this.staffAttendance.pause_start_at, this.staffAttendance.date + ' ' + this.staffAttendance.pause_stop_at, 'minute', '[)')

                if (inPause) {
                    return false
                }
            }
            return dayjs(
                this.staffAttendance.date + ' ' + qH
            ).isBetween(this.staffAttendance.should_start_at, this.staffAttendance.should_left_at, 'minute', '[)')
        },
        isRealPresent (qH) {
            if (this.staffAttendance.pause_start_at && this.staffAttendance.pause_stop_at) {
                const inPause = dayjs(
                    this.staffAttendance.date + ' ' + qH
                ).isBetween(this.staffAttendance.date + ' ' + this.staffAttendance.pause_start_at, this.staffAttendance.date + ' ' + this.staffAttendance.pause_stop_at, 'minute', '[)')

                if (inPause) {
                    return false
                }
            }
            return dayjs(
                this.staffAttendance.date + ' ' + qH
            ).isBetween(this.staffAttendance.start_at, this.staffAttendance.left_at, 'minute', '[)')
        },
        updated () {
            this.$modal.closeAll()
            this.$emit('updated')
        }
    }
}
</script>

<style scoped>
td.bg-attendance-reservation.attendance-absence {
    @apply bg-attendance-absence;
}

td.bg-attendance-presence.attendance-absence {
    @apply bg-attendance-absence;
}
</style>
